import React from "react";
import {
  IconDashboard,
  IconMatches,
  IconPlayers,
  IconIndoor,
  IconT20,
  IconODI,
  IconLeagues,
  IconClose,
} from "./CricketIcons";

interface Props {
  onClose: () => void;
  onNavigate: (screen:
    | "home"
    | "myMatches"
    | "players"
    | "teamsIndoor"
    | "teamsT20"
    | "teamsODI"
    | "leagues"
  ) => void;
  onDebug?: () => void;
  showDebug?: boolean;
}

export default function HamburgerMenu({ onClose, onNavigate, onDebug, showDebug }: Props) {
  const handle = (screen: Parameters<Props["onNavigate"]>[0]) => {
    onClose();
    onNavigate(screen);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[9998]" onClick={onClose}>
      <div
        className="fixed left-0 top-0 h-full w-72 overflow-y-auto z-[9999] shadow-2xl"
        style={{
          background: "linear-gradient(180deg, #0a0f0d 0%, #0d1512 100%)",
          borderRight: "1px solid rgba(255,255,255,0.08)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 flex items-center justify-between" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <h2 className="text-lg font-bold text-white tracking-tight">Cricket</h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
            aria-label="Close menu"
          >
            <IconClose className="w-5 h-5" />
          </button>
        </div>

        <nav className="p-3">
          <SectionLabel>Main Navigation</SectionLabel>
          <MenuButton icon={<IconDashboard className="w-5 h-5" />} label="Home" onClick={() => handle("home")} />
          <MenuButton icon={<IconMatches className="w-5 h-5" />} label="Matches" onClick={() => handle("myMatches")} />
          <MenuButton icon={<IconPlayers className="w-5 h-5" />} label="Player Profiles" onClick={() => handle("players")} />

          <SectionLabel>Teams & Squads</SectionLabel>
          <MenuButton icon={<IconIndoor className="w-5 h-5" />} label="Indoor Teams" onClick={() => handle("teamsIndoor")} />
          <MenuButton icon={<IconT20 className="w-5 h-5" />} label="T20 Teams" onClick={() => handle("teamsT20")} />
          <MenuButton icon={<IconODI className="w-5 h-5" />} label="ODI Teams" onClick={() => handle("teamsODI")} />

          <SectionLabel>Competitions</SectionLabel>
          <MenuButton icon={<IconLeagues className="w-5 h-5" />} label="Leagues" onClick={() => handle("leagues")} />

          {showDebug && (
            <MenuButton
              icon={<span className="text-base">🔧</span>}
              label="Debug Supabase"
              onClick={() => { onClose(); onDebug?.(); }}
              danger
            />
          )}
        </nav>
      </div>
    </div>
  );
}

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-4 pt-4 pb-1.5">
      <span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{children}</span>
    </div>
  );
}

function MenuButton({
  icon,
  label,
  onClick,
  danger,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  danger?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 hover:bg-white/5"
    >
      <span className={danger ? "text-yellow-400" : "text-slate-300"}>{icon}</span>
      <span className={danger ? "text-yellow-400" : "text-white"}>{label}</span>
    </button>
  );
}
